<template>
	<div class="home">
		<header>
			<nav>
				<img src="../assets/images/icons/menu.svg" class="menu-icon" alt="" @click="menu()">
				<ul class="desktop">
					<li><a href="#" v-scroll-to="{ el: '#about-me', offset: -50 }">About me</a></li>
					<li><a href="#" v-scroll-to="{ el: '#portafolio' }">Portafolio</a></li>
					<li><a href="#" v-scroll-to="{ el: '#testimonies', offset: -200 }">Testimonies</a></li>
					<li><a href="#" v-scroll-to="{ el: '#contact', offset: 90 }">Contact</a></li>
					<li class="option__nohref">
						<a>Follow us</a>
						<a class="option__social" href="https://www.instagram.com/llagunoximena/">
							<img src="../assets/images/social/instagram.png" alt="">
						</a>
					</li>
				</ul>

				<ul class="mobile" v-bind:class="{ appear: openMenu, disappear: openMenu === false }">
					<li><a href="#" v-scroll-to="{ el: '#about-me', offset: -50 }">About me</a></li>
					<li><a href="#" v-scroll-to="{ el: '#portafolio' }">Portafolio</a></li>
					<li><a href="#" v-scroll-to="{ el: '#testimonies', offset: -200 }">Testimonies</a></li>
					<li><a href="#" v-scroll-to="{ el: '#contact', offset: 90 }">Contact</a></li>
					<li class="option__nohref">
						<a>Follow us</a>
						<a class="option__social" href="https://www.instagram.com/llagunoximena/">
							<img src="../assets/images/social/instagram.png" alt="">
						</a>
					</li>
				</ul>
			</nav>
		</header>

		<div class="container-fluid">
			<div id="intro">
				<h1 class="hide">Wedding Planner</h1>
				<div class="intro__logo--wrapper">
					<img src="../assets/images/LOGO-ROSA-XIMENA-transparent.png" height="443" width="1460" alt="">
				</div>
			</div>

			<div id="about-me">
				<div class="row">
					<div class="about-me__image">
						<img src="../assets/images/ximena-llaguno.jpg" height="389" width="353" alt="">
					</div>
					<div class="about-me__description">
						<h2>Ximena Llaguno Vidal</h2>
						<p>I graduated from Universidad Panamericana with a major in Service Institution´s Administration (ESDAI). After graduation I worked at the very renown “Club de Banqueros de México” (Mexican banker´s club) which is where I learned the art of wedding and event planning. Twelve years ago I decided to go freelance as a wedding planner, my one and only passion.<br><br>

						I take great pleasure in my duties as a wedding planner because I get to be on the most important moment in the life of two people, and to be able to walk them through this process in order to make this event magnificent is what makes me feel immensely happy. <br><br>

						Every wedding is fully personalized. I focus on helping the couple accomplish everything they imagined for their big day, and making you and your families feel like the guests of honor leaving this important day in our hands. <br><br>

						Fortunately, I only work with the best. Our service suppliers are all tops in their categories! The most renown and professional people that absolutely adore what they do. You can be certain that they will give their best to overcome your expectations, plus, you will be choosing the team that you find most suitable for your big day. <br><br>

						With over 400 weddings of experience, my commitment in yours is that you can feel all the time accompanied by someone who will be your eyes. Be certain that I will give my 100% so that things flow in harmony and you can enjoy both; the process and the wedding. </p>
					</div>
				</div>
			</div>

			<div id="portafolio">
				<div class="row">
					<div class="col s12 portafolio__header">
						<h2 class="center">Portafolio</h2>
					</div>
					<div class="col s12 portafolio__images">
						<div class="image-box">
							<div @click="showModalVideo()" class="video-wrapper"></div>
							<img class="background-image" src="../assets/videos/poster.png" style="filter: blur(2px)">
							<img @click="showModalVideo()" class="icon-image" src="../assets/images/icons/video.svg" alt="">
						</div>
						<div class="image-box" v-for="(image, index) in images" v-if="index <= 8">
							<img class="background-image" :src="getSrc(image.Foto)" alt="" @click="showModalImage(), url = image.Foto, photograph = image.Fotografo, flowers = image.Flores">
						</div>
					</div>
					<div class="col s12 center">
						<a @click="portafolio()">See more</a>
					</div>
				</div>
			</div>

			<div id="testimonies">
				<div class="row">
					<div class="col s12 testimonies__box">
						<carousel
							:per-page="1"
							:autoplay="true"
							:autoplayTimeout="30000"
							:loop="true"
							pagination-active-color="#e24a9b"
							adjustable-height="true"
						>
							<slide>
								<h2>Andrea Marcos Hadjopulos</h2>
								<div class="divider"></div>
								<p>“I wanted to thank you for everything yesterday, the truth is that you made my dream wedding come true. I wouldn´t have changed anything. I had a great time and everybody took the best impression of Mexico and our wedding thanks to you. You made a dream come true, thank you”</p>
							</slide>
							<slide>
								<h2>Sofia Robles Santamarina</h2>
								<div class="divider"></div>
								<p>"Hiring Xime as a wedding planner is the best choice I´ve made… after my husband of course. She was there planning every detail and during the event. <br> She and her staff were solicitous to every detail during the whole time, allowing me, as the bride, and my family to fully enjoy the party. She is a decent, committed person that will always help you host the best possible event without necessarily using the most expensive services. <br> She works with the best providers, just as professional and committed as her. She has impeccable organization and I greatly recommend her”.</p>
							</slide>
							<slide>
								<h2>Alessandra García</h2>
								<div class="divider"></div>
								<p>“Thank you so much! It was the perfect night. All the guests told us over and over again that it was the best wedding they´ve been to. We had the best party! It was a perfect night. <br> We are truly, very happy. <br> I´m really going to miss you, I almost cried saying goodbye.</p>
							</slide>
							<slide>
								<h2>Claudia Gutiérrez y Daniel Abarca</h2>
								<div class="divider"></div>
								<p>“We wanted to thank you for yesterday´s event. It was epic, we had a great time. Everything was impeccable, perfect and there was nothing that we would change. We wanted to send you a great kiss, we love you! Thank you very much”</p>
							</slide>
							<slide>
								<h2>Mónica Robles Santamarina</h2>
								<div class="divider"></div>
								<p>“When I started planning my wedding I thought it was going to be easy, I thought that I could do it without help. A few weeks later I realized all the things that you have to coordinate, organize and have ready before the big day and that´s when I decided to hire Ximena. <br> I don´t know what I would have done without her help. Ximena introduced me to the best service providers, she gave me decoration ideas, invitations, catering, and even helped me with the seating plan. <br> If you are planning on hiring someone to help you with your wedding, stop the search! Ximena and her team showed me that they are professionals, take care of details and they really get envolved in making your wedding the best day of your life”.</p>
							</slide>
							<slide>
								<h2>Maite González Peredo</h2>
								<div class="divider"></div>
								<p>“Ximena Llaguno made our wedding process happier. We had a bad experience with another wedding planner. There are plenty of people today that say they are wedding planners, but Ximena is the only one that knows how to help the bride, the groom and the family really enjoy the event. She makes everything go according to the plan. She is the best wedding and event planner in Mexico.”</p>
							</slide>
							<slide>
								<h2>Beatriz I. Pardo</h2>
								<div class="divider"></div>
								<p>“Since we live in Spain, when we decided to celebrate our wedding in Mexico we knew that we needed to hire a professional that was familiar with the market first hand. <br> We interviewed all the wedding planners that we were referenced to and we were fascinated with Ximena because besides having excellent references and great experience on the area, she always knew how to perfectly understand our needs that weren´t the usual ones and how to fully adapt to our style. <br> Counting on Xime allowed us to organize the event during the days that we visited Mexico making sure nothing was missing and dedicating our time, exclusively to enjoying ourselves. All of the above plus Ximena´s kindness and courteous treatment. She has an infinite adaptation capacity and she used it with us and with our guests that were delighted with her. <br> Back in Spain, we organized, on our account, a much simpler party in which we could confirm all the work that Ximena had saved us and how indispensable her presence had been in order to enjoy our day. <br> Counting on Ximena was, undoubtedly, the best choice that we took during our wedding planning.”</p>
							</slide>
						</carousel>
					</div>
				</div>
			</div>

			<div id="contact">
				 <div class="row">
					<div class="col s12">
						<h2 class="center">Contact</h2>
					</div>
					<div class="col m6 s12 offset-m3">
						<div class="form">
							<div class="input-field col s12">
							 	<input type="text" name="name" id="name" v-model="name" placeholder="Name" required="" autocomplete="off">
							</div>
							<div class="input-field col s12">
							 	<input type="text" name="phone" id="phone" v-model="phone" placeholder="Phone" required="" autocomplete="off">
							</div>
							<div class="input-field col s12">
							 	<input type="text" name="email" id="email" v-model="email" placeholder="Email" required="" autocomplete="off">
							</div>
							<div class="input-field col s12">
								<date-pick v-model="date" name="date" id="date" :inputAttributes="{placeholder: 'Date of your event'}"></date-pick>
							</div>
							<div class="input-field col s12">
							 	<textarea name="massage" id="message" v-model="message" placeholder="Message" required=""></textarea>
							</div>
							<div class="input-field col s12 center">
								<button @click="submit()">Send</button>
							</div>
						</div> 
					</div>
				</div>
			</div>

			<modal name="image-modal" height="auto" v-if="url !== null">
				<div class="header">
					<div class="icon-wrapper" @click="hideModalImage">
						<img src="../assets/images/icons/close.svg" alt="">
					</div>
				</div>
				<div class="image">
					<img :src="getSrc(url)" alt="">
				</div>
				<div class="info">
					<p><b>Photographer</b>: {{ photograph }}</p>
					<p>Decoration: {{ flowers }}</p>
				</div>
			</modal>

			<modal name="video-modal" height="auto">
				<div class="header">
					<div class="icon-wrapper" @click="hideModalVideo">
						<img src="../assets/images/icons/close.svg" alt="">
					</div>
				</div>
				<div class="video">
					<video controls="" autoplay>
						<source src="../assets/videos/video.mp4" type="video/mp4">
					</video>
				</div>
				<div class="info">
					<p><b>Author</b>: franciscoeditor@hotmail.com</p>
				</div>
			</modal>

			<footer>
				<div class="row">
					<div class="col m4 s12 left">
						<p>Ximena Llaguno Wedding Planner ®</p>
					</div>
					<div class="col m4 s12 center">
						<a href="https://www.instagram.com/llagunoximena/">
							<img src="../assets/images/social/instagram.png" alt="">
						</a>
					</div>
					<div class="col m4 s12 right">
						<p><a @click="noticeOfPrivacy()">Notice of Privacy</a></p>
					</div>
				</div>
			</footer>

			<button class="change-language" @click="changeToSpanish">Spanish</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import axios from 'axios';
import { Carousel, Slide } from 'vue-carousel';
import VueSweetalert2 from 'vue-sweetalert2';
import VModal from 'vue-js-modal'
import DatePick from 'vue-date-pick';
import 'vue-date-pick/dist/vueDatePick.css';

Vue.use(VueScrollTo, {
	container: "body",
	duration: 500,
	easing: "ease",
	offset: 0,
	force: true,
	cancelable: true,
	onStart: false,
	onDone: false,
	onCancel: false,
	x: false,
	y: true
})
Vue.use(VueSweetalert2)
Vue.use(VModal)

export default {
	name: 'Spanish',
	data () {
		return {
			// Form
			name: '',
			phone: '',
			email: '',
			date: '',
			message: '',

			// Images
			images: [],
			url: null,
			photograph: '',
			flowers: '',
			// 
			openMenu: false
		}
	},
	methods: {
		changeToSpanish () {
			let language = 'spanish'
			this.$emit('language', 'spanish')
		},
		// 
		submit () {
			if (this.name === '' || this.phone === '' | this.email === '' || this.date === '' || this.message === '') {
				const Toast = this.$swal.mixin({
				  toast: true,
				  position: 'bottom-end',
				  showConfirmButton: false,
				  timer: 3000
				});

				Toast.fire({
				  type: 'error',
				  title: 'Missing fields to complete'
				})
			} else {
				var formData = new FormData()
				formData.append('name', this.name)
				formData.append('phone', this.phone)
				formData.append('email', this.email)
				formData.append('date', this.date)
				formData.append('message', this.message)

				axios.post('http://calpromsa.com.mx/mail.php', formData)

				const Toast = this.$swal.mixin({
				  toast: true,
				  position: 'bottom-end',
				  showConfirmButton: false,
				  timer: 3000
				});

				Toast.fire({
				  type: 'success',
				  title: 'Mail sent'
				})

				this.name = '',
				this.phone = '',
				this.email = '',
				this.date = '',
				this.message = ''
			}
		},

		// 
		getSrc(name) {
	        var images = require.context('../assets/fotografias/', false, /\.jpg$/);
	        return images('./' + name + ".jpg")
	    },
		showModalImage () {
		    this.$modal.show('image-modal');
		},
		hideModalImage () {
			this.$modal.hide('image-modal');
		},
		// 
		showModalVideo () {
		    this.$modal.show('video-modal');
		},
		hideModalVideo () {
			this.$modal.hide('video-modal');
		},
		// 
		menu () {
			if (this.openMenu === false) {
				this.openMenu = true
			} else {
				this.openMenu = false
			}
		},

		portafolio () {
			this.$router.push({name: 'Portafolio'});
		},
		noticeOfPrivacy() {
			this.$router.push({name: 'AvisoPrivacidad'});
		}
	},
	mounted () {
		axios
			.get('static/images.json')
			.then(response => (this.images = response.data))
	},
	components: { Carousel, Slide, DatePick }
};
</script>

<style lang="scss">
$gray: #e6ddcc;
$pink: #e24a9b;
$white: #ffffff;
$black: #000000;

@font-face {
	font-family: 'Montserrat';
	src: url('../assets/font/Montserrat-Regular.ttf');
}

body {
	position: relative;
}

h2 {
	text-transform: uppercase;
	color: $pink;
	font-size: 18px;
	font-weight: bold;
	margin-bottom: 20px;
}

h2, p {
	font-family: 'Montserrat', sans-serif;
}

.swal2-popup {
	box-shadow: 0px 0 10px #000000;
}

.desktop {
	display: flex;
}

.mobile {
	display: none;
}

.appear {
	transform: translateX(0px) translateY(0px);
	-webkit-transition: all .3s ease;
	-moz-transition: all .3s ease;
	-ms-transition: all .3s ease;
	-o-transition: all .3s ease;
	transition: all .3s ease;
}

.disappear {
	transform: translateX(0px) translateY(-500px);
	-webkit-transition: all .3s ease;
	-moz-transition: all .3s ease;
	-ms-transition: all .3s ease;
	-o-transition: all .3s ease;
	transition: all .3s ease;
}

header {
	nav {
		position: fixed;
		top: 0;
		left: 0;
		height: 60px;
		width: 100%;
		background-color: $pink;
		padding: 0px 80px;
		z-index: 3000;
		font-family: 'Montserrat', sans-serif;

		ul {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 60px;

			li {
				list-style-type: none;

				a {
					text-transform: uppercase;
					text-decoration: none;
					color: $white;
					font-size: 13px;
					letter-spacing: 0.7px;
				}
			}

			.option__nohref {
				display: flex;
				justify-content: center;
				align-items: center;
				a {
					cursor: default;
				}

				a:hover {
					background-color: transparent;
				}

				.option__social {
					padding: 0px;
					display: flex;
					align-items: center;
					cursor: pointer;
				}
			}
		}
	}
}

.home {
	#intro {
		position: relative;
		width: 100%;
		margin-top: 60px;
		min-height: calc(100vh - 60px);
		height: auto;
		background-image: url('../assets/fotografias/ramo.jpg');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;

		.intro__logo--wrapper {
			display: flex;
			justify-content: center;
			align-items: center;
			padding: 15px 0;
    		background: linear-gradient(90deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.8) 30%, rgba(255,255,255,0.8) 60%, rgba(255,255,255,0.1) 100%);
			
			img {
				height: auto;
				width: 50%;
			}
		}
	}

	#about-me {
		position: relative;
		padding: 50px 120px;
		background-color: $gray;
		text-align: center;
		font-family: 'Montserrat', sans-serif;

		.row {
			display: flex;
			align-items: center;

			.about-me__description {
				margin-left: 50px;

				p {
					font-size: 14px;
					text-align: justify;
				}
			}
		}
	}

	#portafolio {
		position: relative;
		padding: 50px 120px;

		a {
			color: $pink;
			cursor: pointer;
		 	font-family: 'Montserrat', sans-serif;
		}

		.portafolio__images {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			padding: 0px;

			.image-box {
				position: relative;
				width: 19%;
				padding-top: 19%;
				margin: 0.5%;
				overflow: hidden;

				.background-image, video {
					position: absolute;
					transform: translateX(-50%) translateY(-50%);
					top: 50%;
					left: 50%;
					width: auto;
					max-width: 120%;
					max-height: 120%;
					min-width: 100%;
					min-height: 100%;
					cursor: pointer;
				}

				.icon-image {
				    position: absolute;
				    z-index: 56;
				    height: 70px;
				    transform: translateX(-50%) translateY(-50%);
				    top: 50%;
				    left: 50%;
				    cursor: pointer;
				}

				video {
					max-width: initial;
				}
			}
		}
	}

	#testimonies {
		position: relative;
		padding: 50px 120px;
		background-color: $gray;

		.testimonies__box {
			border: 3px solid $pink;
			width: calc(100% - 6px);
			padding: 20px 30px;

			h2 {
				margin-bottom: 5px;
			}

			.divider {
				background-color: $pink;
				height: 3px;
				width: 90%;
				margin-bottom: 15px;
			}

			p {
				text-align: justify;
			}
		}
	}

	#contact {
		position: relative;
		padding: 50px 120px;
		min-height: 100vh;
		height: auto;
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;

		.form {
			.input-field {
				padding: 0px;
				margin: 5px 0px;

				input, textarea {
					font-family: 'Montserrat', sans-serif;
					background-color: $gray;
					color: $black;
					font-size: 14px;
					margin: 0px;
					border: none;
					padding: 0px 10px;
					width: calc(100% - 20px);
					height: 40px;
				}

				input:focus {
					border: none;
					box-shadow: none;
				}

				textarea {
					width: 100%;
					resize: none;
					padding: 10px;
					height: 100px;
				}

				textarea:focus {
					outline:none;
				}

				#date {
					width: 100%;

					button {
						background: transparent;
						border: none;
						color: black;
						border-radius: 0px;
						padding: 1em .4em;
						letter-spacing: normal;
					}
				}

				button {
					background-color: $pink;
					border: none;
					color: $white;
					border-radius: 100px;
					padding: 10px 30px;
					text-transform: uppercase;
					font-size: 14px;
					letter-spacing: 1.7px;
					cursor: pointer;
				}

				::placeholder {
						color: #989898;
						opacity: 1;
						font-style: italic;
						font-size: 14px;
				}

				:-ms-input-placeholder {
						color: #989898;
						font-style: italic;
						font-size: 14px;
				}

				::-ms-input-placeholder {
						color: #989898;
						font-style: italic;
						font-size: 14px;
				}
			}
		}
	}

	footer {
		background-color: $pink;
		color: $white;
		padding: 20px 120px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		height: 60px;
		position: absolute;
		bottom: 0px;
		width: 100%;
		z-index: 1;

		.row {
			display: flex;
			align-items: center;
			width: 100%;

			.col {
				padding: 0px;
				
				p {
					text-transform: uppercase;
					font-size: 12px;
					letter-spacing: 0.7px;
					a {
						color: white;
						cursor: pointer;
						text-decoration: none;
					}
				}
			}

			.right {
				text-align: right;
			}
		}
	}

	.change-language {
		position: fixed;
		bottom: 5px;
		right: 30px;
		padding: 10px 20px;
		border-radius: 5px;
		font-family: 'Montserrat', sans-serif;
		border: none;
		color: $white;
		background-color: $pink;
		cursor: pointer;
		box-shadow: 0 0 5px black;
	}
}

.VueCarousel-dot-button {
	background-color: red;
}

.v--modal-overlay {
	z-index: 4000;
	.v--modal-background-click {
		display: flex;
		justify-content: center;
		align-items: center;
	    background: rgba(0, 0, 0, 0.90) !important;

	    .v--modal-box {
    	    top: 0 !important;
		    left: 0 !important;
		    width: 80% !important;
    		height: 90vh !important;
    		background-color: transparent;
    		box-shadow: none !important;
    		color: white;
    		font-size: 14px;

    		.header {
    			height: 8%;
    			text-align: center;
    			display: flex;
    			justify-content: center;
    			align-items: center;
    			background-color: transparent;
    			margin-bottom: 0px;

    			.icon-wrapper {
				    width: 30px;
				    height: 30px;
				    background: rgba(255, 255, 255, 0.16);
				    border-radius: 50px;
				    display: flex;
				    justify-content: center;
				    align-items: center;
				    cursor: pointer;

				    img {
				    	height: 10px;
					}
    			}
    		}

    		.image {
    			position: relative;
    			height: 84% !important;

    			img {
			    	width: auto;
			    	height: auto;
			    	min-height: 100%;
			    	max-height: 100%;
		    	    transform: translateX(-50%) translateY(-50%);
				    left: 50%;
				    top: 50%;
				    position: absolute;
				}
    		}

    		.video {
    			display: flex;
    			justify-content: center;
    			align-items: center; 
    			height: 84% !important;
    		}

    		.info {
    			height: 8%;
    			text-align: center;
    		}
		}
	}
}

@media screen and (max-width: 800px) {
	.desktop {
		display: none;
	}

	.mobile {
		display: flex;
	}

	header {
		nav {
			padding: 0px 5% !important;

			.menu-icon {
				display: initial;
				height: 30px;
			    position: absolute;
			    top: 15px;
			    right: 5%;
			}

			.mobile {
				position: absolute;
				width: 100%;
				top: 58px;
				left: 0;
				height: auto;
				flex-direction: column;
				background-color: rgba(226, 74, 155, .85);
				padding-bottom: 20px;

				li {
					height: 80px;
					display: flex;
					align-items: center;
					a {
						font-size: 18px !important;
					}
				}

				.option__nohref {
					flex-direction: column;
					height: auto;
				}
			}
		}
	}

	#intro {
		img {
			width: 80% !important;
		}
	}

	#about-me {
		padding: 50px 5% !important;

		.row {
			flex-direction: column;

			.about-me__image, .about-me__description {
				width: 100% !important;
				margin: 0px !important;

				img {
					width: 90%;
					height: auto !important;
				}
			}
		}
	}

	#portafolio {
		padding: 50px 5% !important;

		.row {
			.portafolio__images {
				margin-bottom: 10px;
				.image-box {
					width: 49% !important;
					padding-top: 49% !important;
				}
			}
		}

		a {
			font-size: 18px;
		}
	}

	#testimonies {
		padding: 50px 5% !important;
	}

	#contact {
		padding: 50px 5% !important;
		padding-bottom: 76px !important;
	}

	footer {
		padding: 20px 5% !important; 
		height: auto !important;

		.row {
			flex-direction: column;

			p {
				text-align: center;
			}
		}
	}

	.v--modal-overlay {
		.v--modal-background-click {
		    .v--modal-box {
	    		.header {
	    			height: 20%;
	    		}

	    		.image {
	    			position: relative;
	    			height: 60% !important;

	    			img {
				    	min-height: auto;
				    	max-width: 100%;
					}
	    		}

	    		.video {
	    			height: 60% !important;
	    			max-width: 100%;

	    			video {
	    				max-width: 100%;
	    			}
	    		}

	    		.info {
	    			height: 20%;
	    		}
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/English.vue